import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSkip"><Path d="M5.93824 4.13538C5.10716 3.58721 4 4.18326 4 5.17884V18.8213C4 19.8169 5.10716 20.413 5.93824 19.8648L16.2801 13.0436C17.0291 12.5495 17.0291 11.4507 16.2801 10.9566L5.93824 4.13538Z" fill="currentColor"/><Path d="M20 4.75009C20 4.33588 19.6642 4.00009 19.25 4.00009C18.8358 4.00009 18.5 4.33588 18.5 4.75009V19.2501C18.5 19.6643 18.8358 20.0001 19.25 20.0001C19.6642 20.0001 20 19.6643 20 19.2501V4.75009Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSkip;
